import FilterList from 'govbr.frontend.policy/components/Blocks/Search/components/FilterList';

export default FilterList;
